"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactRouter = require("react-router");

var LinkCard = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(LinkCard, _React$PureComponent);

  function LinkCard() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = LinkCard.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        path = _this$props.path,
        classes = _this$props.classes,
        children = _this$props.children,
        theme = _this$props.theme;
    var addedClasses = classes.map(function (currentClass) {
      return theme[currentClass];
    });
    return /*#__PURE__*/_react["default"].createElement(_reactRouter.Link, {
      className: _clsx["default"].apply(void 0, [theme.optionCard].concat(addedClasses)),
      to: path
    }, children);
  };

  return LinkCard;
}(_react["default"].PureComponent);

exports["default"] = LinkCard;
LinkCard.displayName = 'LinkCard';
LinkCard.defaultProps = {
  classes: []
};